import PageTitle from "components/PageTitle";
import Table from "components/TableComp";
import HyperDatepicker from "components/Datepicker";
import FancySelect from "components/FancySelect";
import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { get } from "helpers";
import { addDays, endOfDay, format, startOfDay, subDays } from "date-fns";
import { IPagination } from "types/generics/IPagination";
import { IColaborador, IPaciente, ISelect } from "types";
import ImageComponent from "components/Image";

interface ISubstituicao {
  id?: number;
  novo?: {
    id: number;
    apelido: string;
    foto: string;
  };
  paciente?: {
    id: number;
    apelido: string;
  };
  usuario?: string;
  createdAt?: string;
  data_inicio?: string;
  data_fim?: string;
  agendamento?: {
    id: number;
    tipo: string;
    horario: string;
    horario_fim: string;
  };
  atendimento?: {
    id?: number;
    data_inicio?: string;
    data_fim?: string;
  };
  created_at: Date;
}

const dateValue = (value?: string | Date | null) => {
  if (!value) return "-";

  const date = typeof value === "string" ? new Date(value) : value;

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return format(date, "dd/MM/yyyy");
};

const timeRangeValue = (
  start?: string | Date | null,
  end?: string | Date | null,
) => {
  if (!start && !end) return "-";

  const startDate = start ? new Date(start) : null;
  const endDate = end ? new Date(end) : null;

  if (startDate && endDate) {
    return `${format(startDate, "HH:mm")} - ${format(endDate, "HH:mm")}`;
  }

  if (startDate) {
    return format(startDate, "HH:mm");
  }

  if (endDate) {
    return format(endDate, "HH:mm");
  }

  return "-";
};

const SubstituidoEm: React.FC<{ row: { original: ISubstituicao } }> = ({
  row,
}) => {
  const value = row.original.created_at;
  console.log("value", value);
  return (
    <span
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      {dateValue(value)}
    </span>
  );
};

const ColaboradorColumn: React.FC<{ row: { original: ISubstituicao } }> = ({
  row,
}) => {
  console.log("imagem: ", row?.original?.novo);
  return (
    <>
      <div>
        <ImageComponent
          className="rounded-circle avatar-xs"
          avatarObj={{ path: row?.original?.novo?.foto }}
        />
        <span className="ms-2">{row.original?.novo?.apelido || "-"}</span>
      </div>
    </>
  );
};

const PacienteColumn: React.FC<{ row: { original: ISubstituicao } }> = ({
  row,
}) => {
  return <span>{row.original?.paciente?.apelido || "-"}</span>;
};

const AtendimentoColumn: React.FC<{ row: { original: ISubstituicao } }> = ({
  row,
}) => {
  return (
    <span>
      {row.original.atendimento?.data_inicio
        ? `${dateValue(row.original.atendimento.data_inicio)} ${timeRangeValue(
            row.original.atendimento?.data_inicio || row.original.data_inicio,
            row.original.atendimento?.data_fim || row.original.data_fim,
          )}`
        : "-"}
    </span>
  );
};

const AgendamentoColumn: React.FC<{ row: { original: ISubstituicao } }> = ({
  row,
}) => {
  return <span>{row.original.agendamento?.tipo}</span>;
};

const AgendamentoHorarioColumn: React.FC<{
  row: { original: ISubstituicao };
}> = ({ row }) => {
  return (
    <span>
      {row.original.agendamento?.horario ?? ""} -{" "}
      {row.original.agendamento?.horario_fim ?? ""}
    </span>
  );
};

export default function HistoricoSubstituicao() {
  const [api, setApi] = useState<null | IPagination<ISubstituicao>>(null);
  const [pageIndexController, setPageIndexController] = useState(0);
  const [patient, setPatient] = useState<null | ISelect>(null);
  const [patients, setPatients] = useState<ISelect[]>([]);
  const [colaborador, setColaborador] = useState<ISelect | null>(null);
  const [colaboradores, setColaboradores] = useState<ISelect[]>([]);
  const [startDate, setStartDate] = useState<Date>(subDays(new Date(), 7));
  const [endDate, setEndDate] = useState<Date>(addDays(new Date(), 7));
  const [permanente, setPermanente] = useState<ISelect>({
    value: 0,
    label: "Não",
  });

  useEffect(() => {
    const fetchMetadata = async () => {
      const [pacientesResponse, colaboradoresResponse] = await Promise.all([
        get<IPagination<IPaciente>>("/select-paciente"),
        get<IPagination<IColaborador>>("/select-colaborador"),
      ]);

      setPatients(
        pacientesResponse.data.result.map((item) => ({
          label: item.apelido,
          value: item.id,
        })),
      );

      setColaboradores(
        colaboradoresResponse.data.result.map((item) => ({
          label: item.apelido,
          value: item.id,
        })),
      );
    };

    fetchMetadata();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await get<IPagination<ISubstituicao>>(
        "/troca-atendimento",
        {
          currentPage: (pageIndexController ?? 0) + 1,
          paciente_id: patient?.value ?? "",
          permanente: permanente.value === 0 ? "false" : "true",
          colaboradornovo_id: colaborador?.value ?? "",
          dataInicio: startDate?.toISOString() ?? new Date(0).toISOString(),
          dataFim: endDate?.toISOString() ?? new Date().toISOString(),
          ativos: permanente.value === 2,
        },
      );
      setApi(data);
    };

    fetchData();
  }, [
    patient,
    colaborador,
    startDate,
    endDate,
    pageIndexController,
    permanente,
  ]);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          {
            label: "Histórico de Substituição",
            path: "/historico-substituicao",
            active: true,
          },
        ]}
        mdiIcon="swap-horizontal"
        title="Histórico de Substituição"
      />
      <Card>
        <Card.Body>
          <Row className="mb-3">
            <Col lg={2}>
              <FancySelect
                value={permanente}
                label="Fixa"
                name="permamemte"
                placeholder="Selecione"
                options={[
                  { label: "Não", value: 0 },
                  { label: "Sim - Todas", value: 1 },
                  { label: "Sim - Ativas", value: 2 },
                ]}
                onChange={(e) => setPermanente(e)}
              />
            </Col>
            <Col lg={3}>
              <FancySelect
                value={patient}
                label="Paciente"
                name="patient"
                placeholder="Selecione"
                options={[{ label: "Todos", value: "" }, ...patients]}
                onChange={(e) => setPatient(e)}
              />
            </Col>
            <Col lg={3}>
              <FancySelect
                value={colaborador}
                label="Colaborador"
                name="colaborador"
                placeholder="Selecione"
                options={[{ label: "Todos", value: "" }, ...colaboradores]}
                onChange={(e) => setColaborador(e)}
              />
            </Col>
            {permanente.value !== 2 && (
              <Col
                lg={3}
                style={{
                  zIndex: 4,
                }}
              >
                <Row>
                  <Col lg={6}>
                    <div>
                      <label className="form-label">Data início</label>
                      <br />
                      <HyperDatepicker
                        hideAddon={true}
                        value={startDate}
                        onChange={(date) => {
                          setStartDate(startOfDay(date));
                        }}
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                  </Col>
                  <Col lg={6} className="mt-2 mt-lg-0">
                    <div>
                      <label className="form-label">Data fim</label>
                      <br />
                      <HyperDatepicker
                        hideAddon={true}
                        value={endDate}
                        onChange={(date) => {
                          setEndDate(endOfDay(date));
                        }}
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
          <Table
            columns={
              permanente.value !== 0
                ? [
                    {
                      Header: "Horário",
                      accessor: "created_at",
                      Cell: AgendamentoHorarioColumn,
                    },
                    {
                      Header: "Agendamento",
                      accessor: "agendamento",
                      Cell: AgendamentoColumn,
                    },
                    // {
                    //   Header: "Horário",
                    //   accessor: "id",
                    //   Cell: TimeColumn,
                    // },
                    {
                      Header: "Colaborador substituto",
                      accessor: "novo",
                      Cell: ColaboradorColumn,
                    },
                    {
                      Header: "Paciente",
                      accessor: "paciente",
                      Cell: PacienteColumn,
                    },
                    {
                      Header: "Substituido em",
                      accessor: "createdAt",
                      Cell: SubstituidoEm,
                    },
                  ]
                : [
                    {
                      Header: "Atendimento",
                      accessor: "atendimento",
                      Cell: AtendimentoColumn,
                    },
                    // {
                    //   Header: "Horário",
                    //   accessor: "id",
                    //   Cell: TimeColumn,
                    // },
                    {
                      Header: "Colaborador substituto",
                      accessor: "novo",
                      Cell: ColaboradorColumn,
                    },
                    {
                      Header: "Paciente",
                      accessor: "paciente",
                      Cell: PacienteColumn,
                    },
                    {
                      Header: "Substituido em",
                      accessor: "createdAt",
                      Cell: SubstituidoEm,
                    },
                  ]
            }
            data={api ? api.result : []}
            tableClass="table-striped"
            pagination={true}
            pageCount={api ? api.totalPage : 0}
            changePage={setPageIndexController}
            pageIndex={pageIndexController}
          />
        </Card.Body>
      </Card>
    </>
  );
}
